
/**
 * Custom component for Christmas Libations default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2025-11-05 (1.0.0) (jhoward)
 *    - Copy from ChristmasLibations_defaultSection.vue component to ChristmasLibations2025_defaultSection.vue component.
 *    - Update divider image in ChristmasLibations2025_defaultSection to the 2025 version.
 *    - Update background images in ChristmasLibations2025_defaultSection to the 2025 versions and refactor to support more device types.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection,
  },
  name: "ChristmasLibations_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: 'christmas-drink-item',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
})
